import React from "react";
import dataImg from "../../assets/no-data-found.gif";
import "../../styles/Layout/_NoDataFound.scss";

const NoDataFound = () => (
  <div className="no-data--found">
    <div className="no-data--info">
      <div className="no-data--found__img">
        <img src={dataImg} alt="No Data Found" />
        <p>No Data Found</p>
      </div>
    </div>
  </div>
);

export default NoDataFound;
